"use client";
import * as React from "react";
const SvgTaskOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.63 0h-6.5A1.6 1.6 0 0 0 .5 1.6v12.8c0 .88.72 1.6 1.62 1.6h9.75c.9 0 1.63-.72 1.63-1.6V4.8zm3.24 14.4H2.13V1.6H7.8v4h4.07zM4.43 8.84 3.26 9.97l2.88 2.83 4.6-4.53-1.15-1.13-3.44 3.4z" }));
export {
  SvgTaskOutlined as default
};
